import {
  FusionApi,
  FusionMelcoFusionModelsCustomProductView,
  SharedserviceMelcoFusionModelsUserBlankListItem,
  useAPIAction,
} from "melco-shared-logic";

export const useFixProductSchema = () => {
  return useAPIAction(
    FusionApi,
    async (
      api,
      blank: SharedserviceMelcoFusionModelsUserBlankListItem,
      view_list?: FusionMelcoFusionModelsCustomProductView[]
    ) => {
      const data = await api.fusionCustomProductsFixSchema({
        fusionMelcoFusionModelsCustomProduct: {
          blank: {
            id: blank.id,
          },
          view_list,
        },
      });

      return {
        successMessages: [],
        data,
      };
    },
    {
      translationPrefix: "products.actions.change_blank",
    }
  );
};
